import {
  EuiButton,
  EuiButtonEmpty,
  EuiCallOut,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
} from "@inscopix/ideas-eui";
import { useState } from "react";
import { useDataTableContext } from "../store/DataTableProvider";
import { addUtilityToastSuccess } from "utils/addUtilityToastSuccess";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";
import {
  FileAssignmentsWarning,
  useFilesToDeleteForCellRanges,
} from "./FileAssignmentsWarning";

interface ModalDeleteRowsProps {
  tableId: string;
  rowIds: string[];
  onClose: () => void;
}

export const ModalDeleteRows = ({
  tableId,
  rowIds,
  onClose,
}: ModalDeleteRowsProps) => {
  const files = useFilesToDeleteForCellRanges({ rowIds });
  const deleteRows = useDataTableContext((s) => s.deleteRows);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);
    const { error } = await deleteRows({
      tableId,
      rowIds: rowIds,
      fileIds: files.map((f) => f.id),
    });
    setIsLoading(false);

    if (error === undefined) {
      addUtilityToastSuccess("Row(s) deleted");
    } else {
      addUtilityToastFailure("Failed to delete row(s)");
    }

    onClose();
  };

  return (
    <EuiModal onClose={onClose}>
      <EuiModalHeader>
        <EuiModalHeaderTitle component="h3">
          {rowIds.length === 1
            ? "Delete Row"
            : `Delete ${rowIds.length} Selected Rows`}
        </EuiModalHeaderTitle>
      </EuiModalHeader>
      <EuiModalBody>
        <EuiCallOut
          title="Proceed with caution!"
          color="warning"
          iconType="warning"
        >
          <p>
            Cells in the {rowIds.length > 1 ? "deleted rows" : "deleted row"}{" "}
            may be referenced in other tables. Deleting these rows might cause
            unwanted changes to your data.
          </p>

          {files.length > 0 && <FileAssignmentsWarning files={files} />}
        </EuiCallOut>
      </EuiModalBody>
      <EuiModalFooter>
        <EuiButtonEmpty onClick={onClose}>Cancel</EuiButtonEmpty>
        <EuiButton
          isLoading={isLoading}
          fill
          color="danger"
          onClick={() => void handleSubmit()}
        >
          Delete
        </EuiButton>
      </EuiModalFooter>
    </EuiModal>
  );
};
